import Bread from 'assets/images/bread.svg';
import Burger from 'assets/images/burger.svg';
import Drinks from 'assets/images/drinks.svg';
import Pizza from 'assets/images/pizza.svg';
import Sandwich from 'assets/images/sandwich.svg';

//icon food
export { Bread, Burger, Drinks, Pizza, Sandwich };

//options food
export const typeOptions = [
	{
		img: Burger,
		name: 'Burgers',
	},
	{
		img: Bread,
		name: 'Breads',
	},
	{
		img: Sandwich,
		name: 'Sandwiches',
	},
	{
		img: Drinks,
		name: 'Drinks',
	},
	{
		img: Pizza,
		name: 'Pizzas',
	},
];

//options checkbox food
export const optionCheckbox = ['Under $100', 'Above $100', 'Under $50', '$50 to $100'];
